import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { mapSelectors } from "../../store/selectors";
import FlexWrapper from "../../styles/shared/FlexWrapper";
import LoadingSpinner from "../loaders/LoadingSpinner";
import SearchFormContainer from "../searchForm/SearchFormContainer";
import TrackMyLocation from "../trackYourLoaction/TrackMyLocation";

const TopBarWrap = styled.div`
  background-color: #f0f0f0;
  padding: 2.5rem 0;
`;

const TopBar = () => {
  const isLoading = useSelector(mapSelectors.getLoadingStatus);

  return (
    <TopBarWrap>
      <div className="container">
        <FlexWrapper alignItems="center">
          <SearchFormContainer />
          <TrackMyLocation />
          {isLoading && <LoadingSpinner />}
        </FlexWrapper>
      </div>
    </TopBarWrap>
  );
};

export default TopBar;
